import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import './JabutisHighlights.css';

export interface JabutiHighlight {
  id: string;
  tipo: string;
  numero: number;
  ano: number;
  level: 'low' | 'medium' | 'high' | string;
  score: number;
  one_liner: string;
}

interface Props {
  highlights: JabutiHighlight[];
  limit?: number;
  title?: string;
  className?: string;
}

export default function JabutisHighlights({
  highlights,
  limit = 6,
  title = 'Sinais de atenção · IA',
  className,
}: Props) {
  if (!highlights || highlights.length === 0) return null;
  const items = highlights.slice(0, limit);
  return (
    <section className={`jabutis-summary-card${className ? ` ${className}` : ''}`}>
      <span className="eyebrow eyebrow-jabuti">
        <AlertTriangle size={12} /> {title}
      </span>
      <ul className="jabutis-summary-highlights">
        {items.map((h) => (
          <li key={h.id}>
            <Link to={`/detail/${h.id}`} className="jabutis-summary-item">
              <span className={`top-jabuti-pill pill-${h.level}`}>
                {h.level === 'high' ? 'Alto' : h.level === 'medium' ? 'Médio' : 'Baixo'} ·{' '}
                {Math.round(h.score)}
              </span>
              <span className="jabutis-summary-ref">
                {h.tipo} {h.numero}/{h.ano}
              </span>
              <span className="jabutis-summary-line">{h.one_liner}</span>
              <ArrowRight size={12} className="jabutis-summary-arrow" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
